export default __webpack_public_path__ + "static/media/slide16.25c05304.jpg";